import React from "react";
import {useTranslation} from "react-i18next";
import {getBuildingUsersCardModel} from "../Model/Model";
import CustomCard from "../../../components/CustomCard";
import CustomTooltip from "../../../components/CustomTooltip";
import ButtonSubAction from "../../../components/buttons/ButtonSubAction";
import {IconInfoCard} from "../../../components/buttons/IconButtons";
import BuildingResidentsDoughnut from "./BuildingResidentsDoughnut";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 */

const BuildingUsersResume = ({
    buildingDetail,
    setUserClassificationSelected,
    setShowManagerUserListModal
}) => {
    const {t} = useTranslation();
    // Verified and unverified residents counted by the building detail
    const buildingStatus = getBuildingUsersCardModel(buildingDetail);
    const summary = buildingStatus.SUMMARY.list;

    return (
        <div className={"mt-3"}>
            {
                Object.entries(buildingStatus).map(([key, item]) => {
                     return <div className={"mb-3"}>
                         <div className={`${item.classCard} card-border-8px p-2`}>
                             <div className={"row"}>
                                 { item.list.map((x, index) => {
                                     return <div className={`${x.cols} p-1`}>
                                         <CustomCard classCard={`${x.classCard} card-border-8px position-relative`} classContent={"p-0"}>
                                             <div className={"position-absolute t-negative-4px r-3px"}>
                                                 <CustomTooltip
                                                     text={<>
                                                         <p className={"ibl-font-w-600 fs-12px"}>{t(x.titleTrans)}</p>
                                                         <ButtonSubAction
                                                             id={`btn_bur_more_details_${index}`}
                                                             name="click_here_to_view_more_details"
                                                             onClick={() => {
                                                                 setShowManagerUserListModal(true);
                                                                 setUserClassificationSelected(x);
                                                             }}
                                                             className='btn-transparent font-color-general-00 px-0 mx-0'
                                                         />
                                                     </>}
                                                     placement={"top"}
                                                 >
                                                     <IconInfoCard className={x?.infoColor + " w-h-14px"}/>
                                                 </CustomTooltip>
                                             </div>
                                             <div className={"text-center"}>
                                                 <x.Icon className={`${x?.infoColor}`} />
                                             </div>
                                             <div className={"text-center"}>
                                                 <p className={`${x.fontColor} ibl-font-w-700 fs-24px`}>{x.total}</p>
                                             </div>
                                         </CustomCard>
                                     </div>
                                 })}
                             </div>
                         </div>
                     </div>
                })
            }
            <BuildingResidentsDoughnut
                summary={summary}
                totalResidents={buildingDetail?.totalResidents}
            />
        </div>
    );
};

export default BuildingUsersResume;
